import { useEffect } from 'react';
import { useRefCallback } from '../../../callback/ref-callback';
import { addMutationHandler, isClient, removeMutationHandler } from '../../co-dom';
import { useRefGetter } from '../../use';
export function useScroll(enable, onScroll) {
  var onScrollCallback = useRefCallback(onScroll);
  var enableGetter = useRefGetter(enable);
  useEffect(function () {
    var callback = function callback() {
      if (enableGetter()()) {
        onScrollCallback();
      }
    };

    if (isClient()) {
      addMutationHandler(callback, {
        scroll: true
      });
      return function () {
        removeMutationHandler(callback);
      };
    }
  }, []);
}